import { useState, useEffect } from "react";
import ApiConfig from "../services/ApiConfig";
import axios from "axios";

const GetEventStatus = (eventId, environment) => {
    return new Promise(async (resolve, reject) => {
        try {
            const config = await ApiConfig();
            config.method = "get";
            config.url +=
                "/get_event_status_view?" +
                "environment=" +
                environment +
                "&event_id=" +
                eventId;
            const response = await axios(config);
            resolve(response.data);
        } catch (error) {
            reject(error.response ? error.response.data : "Failed to load event status");
        }
    });
};

const useGetEventStatus = (eventId, environment) => {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [eventStatus, setEventStatus] = useState(null);

    const load = async (refetch) => {
        if (refetch) {
            setIsRefetching(true);
        }
        try {
            const response = await GetEventStatus(eventId, environment);
            setIsLoaded(true);
            if (response && Object.keys(response).length) {
                setEventStatus(response);
            } else {
                setError("Event not found!");
            }
        } catch (error) {
            setError(error);
        } finally {
            setIsRefetching(false);
        }
    };

    const refetchEventStatus = () => load(true);

    useEffect(() => {
        load(false);
    }, []);

    return { eventStatus, error, isLoaded, isRefetching, refetchEventStatus };
};

export default useGetEventStatus;
